import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';

interface UsePosRegistrationProps {
  id?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useBillingBillReissueFiscalDocument = ({ id, onSuccess, onError }: UsePosRegistrationProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingBillReissueFiscalDocument', id],
    mutationFn: async () => privateAxios.put(`/billing/bills/${id}/reissue_fiscal_document`),
    onSuccess,
    onError,
  });
};
